import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private readonly subject$ = new Subject<string | null>();

  sendState(state: string): void {
    this.subject$.next(state);
  }

  clearState(): void {
    this.subject$.next(null);
  }

  getState(): Observable<string | null> {
    return this.subject$.asObservable();
  }
}
